const lang = {
  title_page: process.env.MIX_APP_NAME,
  notification: '二段階認証に複数回失敗したため、アカウントがロックされました。',
  info: 'お手数ですが、ご利用いただいているアカウントのメールアドレスより、<br><a href="mailto:info@aidiot.jp" style="text-decoration: underline;">info@aidiot.jp</a> までロック解除のご依頼をお送りください。',
  btn_back_login: 'ログイン画面へ',
  email_error_message: 'The メールアドレス is lock out.',
}

export default lang
